import(/* webpackMode: "eager" */ "/app/apps/user/app/global-error.tsx");
